import React from "react";
import { Page } from "components/common";
import { Row, Col, Nav } from "reactstrap";
import { HoverCard } from "components";

import img1 from "../../../assets/images/icons8-tax-32.png";
import img2 from "../../../assets/images/icons8-tracking-80.png";
import img3 from "../../../assets/images/icons8-currencies-68.png";
import img4 from "../../../assets/images/icons8-invoice-48.png";
import img5 from "../../../assets/images/icons8-email-open-50.png";
import img6 from "../../../assets/images/endofservice-icon.svg";
import img7 from "../../../assets/images/approved_icon.svg";

const AccountingSettings = ({ match, t }) => (
  <Page title={t("Accounting Settings")} className="general-settings">
    <hr />
    <Row>
      <Nav>
        <Col md={6}>
          <HoverCard
            imgSrc={img1}
            to={`/accounting/settings/tax_rates`}
            title="Tax Rates"
            description="Add, edit and delete the tax rates you want to use."
          />
        </Col>
        <Col md={6}>
          <HoverCard
            imgSrc={img1}
            to={`/tax_details`}
            title="Organisation Tax Details"
            description="View your organisation taxes for submitting tax returns."
          />
        </Col>
        <Col md={6}>
          <HoverCard
            imgSrc={img2}
            to={`/accounting/settings/tracking`}
            title="Tracking"
            description="Manage tracking items for more powerful reporting."
          />
        </Col>
        <Col md={6}>
          <HoverCard
            imgSrc={img3}
            to={`/accounting/settings/currencies`}
            title="Currencies"
            description="Add foreign currencies that your organization uses."
          />
        </Col>
        <Col md={6}>
          <HoverCard
            imgSrc={img4}
            to={`/accounting/settings/invoice_settings`}
            title="Invoice Settings"
            description="Add a custom header, footer and logo to your invoices."
          />
        </Col>
        <Col md={6}>
          <HoverCard
            imgSrc={img5}
            to={`/accounting/settings/email_templates`}
            title="Email Templates"
            description="Set email template content."
          />
        </Col>
        <Col md={6}>
          <HoverCard
            imgSrc={img6}
            to={`/accounting/settings/custom_settings`}
            title="Custom Organisation Settings"
            description={t("If you need to customize your organisation settings.")}
          />
        </Col>
      </Nav>
    </Row>
  </Page>
);

export default AccountingSettings;
